<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_xi"></a><em>Christmas is coming, the goose is getting fat,<br/>Please put a penny in the old man’s hat.</em><br/><em>If you haven’t got a penny, a ha’penny will do,<br/>If you haven’t got a ha’penny, then God bless you!</em></p>
<p class="right-para">—Traditional British children’s rhyme</p>
<p class="para"> </p>
<p class="para">“When I was a lad,” replied the foreman, “young ladies was young ladies. And young gentlemen was young gentlemen. If you get my meaning.”</p>
<p class="indent-para">“What this country wants,” said Padgett, “is a ’Itler.”</p>
<p class="right-para">—Dorothy L. Sayers, <em>Gaudy Night</em> (1935)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?7e1d93f4